import { render, staticRenderFns } from "./ChangeCaptainReasons.vue?vue&type=template&id=3f931ff0&scoped=true"
import script from "./ChangeCaptainReasons.vue?vue&type=script&lang=js"
export * from "./ChangeCaptainReasons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f931ff0",
  null
  
)

export default component.exports